/** Every route in the app. Order matters only where two patterns could match the same URL (static paths first). */
import { routes as auth } from './auth/pages.js';
import { routes as publicPages } from './public/pages.js';
import { routes as publicMore } from './public/more.js';
import { routes as messages } from './messages/pages.js';
import { routes as recordings } from './recordings/pages.js';
import { routes as classList } from './classes/list.js';
import { studentClassRoute, trainerClassRoute } from './classroom/room.js';
import { dashboard as studentDashboard } from './student/dashboard.js';
import { routes as learn } from './student/learn.js';
import { routes as progress } from './student/progress.js';
import { routes as opportunities } from './student/opportunities.js';
import { routes as studentBilling } from './student/billing.js';
import { routes as studentProfile } from './student/profile.js';
import { routes as network } from './network/pages.js';
import { routes as professionalAccount } from './professional/account.js';
import { routes as coaching } from './professional/coaching.js';
import { routes as work } from './professional/work.js';
import { routes as projects } from './projects/pages.js';
import { routes as orgRequirements } from './org/requirements.js';
import { routes as orgAccount } from './org/account.js';
import { routes as adminOverview } from './admin/overview.js';
import { routes as adminPeople } from './admin/people.js';
import { routes as adminLearning } from './admin/learning.js';
import { routes as adminMatching } from './admin/matching.js';
import { routes as adminTrust } from './admin/trust.js';
import { routes as adminSettings } from './admin/settings.js';
import { routes as adminEnquiries } from './admin/enquiries.js';
import { routes as adminCoupons } from './admin/coupons.js';
import { routes as adminDemos } from './admin/demos.js';
import { routes as studentTests } from './tests/student.js';
import { routes as trainerTests } from './tests/trainer.js';
import { routes as adminTests } from './tests/admin.js';

export const allRoutes = [
  ...publicPages,
  ...publicMore,
  ...auth,
  studentDashboard,
  ...learn,
  ...classList,
  studentClassRoute,
  trainerClassRoute,
  ...recordings,
  ...progress,
  ...opportunities,
  ...studentBilling,
  ...studentProfile,
  ...messages,
  ...network,
  ...professionalAccount,
  ...coaching,
  ...work,
  ...projects,
  ...orgRequirements,
  ...orgAccount,
  ...adminOverview,
  ...adminPeople,
  ...adminLearning,
  ...adminMatching,
  ...adminTrust,
  ...adminSettings,
  ...adminEnquiries,
  ...adminCoupons,
  ...adminDemos,
  ...studentTests,
  ...trainerTests,
  ...adminTests,
];
